/** @format */

const CHART_LIST = [
  {
    CHART_NAME: 'sales_by_month',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      multiValueLabel: true,
    },
  },
  {
    CHART_NAME: 'sales_by_branch',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_category',
    CHART_TYPE: 'pie',
  },
  {
    CHART_NAME: 'sales_by_subcategory',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_brands',
    CHART_TYPE: 'pie',
  },
  {
    CHART_NAME: 'sales_by_subbrand',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_product',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_model',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_purity',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_salesmen',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_branch_type',
    CHART_TYPE: 'pie',
  },
  {
    CHART_NAME: 'sales_by_bill_type',
    CHART_TYPE: 'pie',
  },
  {
    CHART_NAME: 'sales_by_maincategory',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_department',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_lob',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_supplier',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_shade',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_fabric',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_size',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_state',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_city',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_area',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_design',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_material',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_section',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_saletype',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_verticle',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_customer',
    CHART_TYPE: 'bar',
  },
  {
    CHART_NAME: 'sales_by_industry',
    CHART_TYPE: 'bar',
  },
  // jwelsoft
  {
    CHART_NAME: 'sales_by_basemetal',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_primarygroup',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_secondarygroup',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_lastgroup',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_stone',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
  {
    CHART_NAME: 'sales_by_vouchertype',
    CHART_TYPE: 'bar',
    CHART_CONFIG: {
      horizontal: true,
    },
  },
];

const NUM_CONDENSER = 100000;

const DPS_CHARTS = [
  'bar',
  'column',
  'marker',
  'bubble',
  'pie',
  'donut',
  'slice',
];

export { CHART_LIST, NUM_CONDENSER, DPS_CHARTS };
